import { Card, Col, Row } from "react-bootstrap";
import { vendorString } from "../../../utils/string";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import defaultImg from "../../../_uLearn/assets/media/svg_uLearn/default.svg";
import PhoneCall from "../../../_uLearn/assets/media/svg_uLearn/phone-call.svg";
import Email from "../../../_uLearn/assets/media/svg_uLearn/email.svg";
import APICallService from "../../../api/apiCallService";
import { VENDORS } from "../../../api/apiEndPoints";
import Loader from "../../../Global/loader";
import Method from "../../../utils/methods";
import { BasicDetails } from "./tabs/basic-details";
import AllServices from "./tabs/service-details";
const VendorProfile = () => {
  const [fetchLoader, setFetchLoader] = useState(true);
  const location = useLocation();
  const state: any = location.state;
  const [vendorDetails, setVendorDetails] = useState<any>();
  const [tab, setTab] = useState([
    {
      name: "Basic Details",
      content: <BasicDetails basicDetails={vendorDetails} />,
      value: "1",
    },
  ]);
  const [currentTab, setCurrentTab] = useState(tab[0]);
  useEffect(() => {
    if (!state?._id) {
      return window.history.back();
    }
    (async () => {
      setFetchLoader(true);
      await fetchVendorDetails();
      setFetchLoader(false);
    })();
  }, []);
  const fetchVendorDetails = async () => {
    let apiService = new APICallService(VENDORS.getVendorDetails, state?._id);
    let response: any = await apiService.callAPI();
    setVendorDetails(response);
    setTab([
      {
        name: "Basic Details",
        content: <BasicDetails basicDetails={response} />,
        value: "1",
      },
      {
        name: "Service details",
        content: <AllServices serviceDetails={response} />,
        value: "2",
      },
    ]);
    setCurrentTab({
      name: "Basic Details",
      content: <BasicDetails basicDetails={response} />,
      value: "1",
    });
  };
  const handleSelectTab = (tab: any) => {
    if (tab.value === "1") {
      setCurrentTab({
        name: "Basic details",
        content: <BasicDetails basicDetails={vendorDetails} />,
        value: "1",
      });
    } else if (tab.value === "2") {
      setCurrentTab({
        name: "Service details",
        content: <AllServices serviceDetails={vendorDetails} />,
        value: "2",
      });
    }
  };
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <Link
            to={"/"}
            className={
              current.name === tab.name
                ? "nav-link active text-active-dark"
                : "nav-link text-hover-dark"
            }
            data-bs-toggle="tab"
            onClick={() => handleSelectTab(tab)}
          >
            {tab.name}
          </Link>
        </li>
      );
    });
    return allTabs;
  };
  return (
    <>
      <Row className="mb-7 align-items-center">
        <Col md>
          <h1 className="fs-22 fw-bolder mb-md-0 mb-3">
            {vendorString.VendorProfile}
          </h1>
        </Col>
      </Row>
      {fetchLoader ? (
        <>
          <div className="d-flex justify-content-center">
            <Loader fetchLoader={fetchLoader} />
          </div>
        </>
      ) : (
        <>
          <Card className="border border-custom-color mb-7">
            <Card.Body className="pt-9 pb-0">
              <div className="position-absolute top-0 end-0">
                <div className="d-flex justify-content-center align-items-center bg-light-warning p-3 px-4 border-r10px">
                  <span className="fw-600 fs-15">
                    {vendorString.joiningDate}:
                  </span>
                  <span className="ms-1 fw-600 text-black fs-15">
                    {Method.convertDateToDDMMYYYY(vendorDetails?._createdAt)}
                  </span>
                </div>
              </div>
              <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                <div className="me-9">
                  <div className="symbol symbol-200px symbol-fixed border border-r10px position-relative">
                    <div className="image-input d-flex flex-center rounded w-lg-200px w-150px h-lg-200px h-150px">
                      <div
                        className="image-input-wrapper shadow-none bgi-contain bgi-position-center border-r10px w-100 h-100"
                        style={{
                          background: `url(${
                            vendorDetails?.image || defaultImg
                          })`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center center",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="row align-items-center flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-column mb-2">
                        <h3 className="text-black fs-22 fw-bolder">
                          {vendorDetails?.businessName}
                        </h3>
                        <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                          <div className="d-flex align-items-center text-black fs-16 fw-500 me-5 mb-2">
                            <span className="svg-icon svg-icon-4 me-2">
                              <img src={PhoneCall} alt="Phone number" />
                            </span>{" "}
                            {vendorDetails?.phoneCountry +
                              " " +
                              vendorDetails?.phone}
                          </div>
                          <div className="d-flex align-items-center text-black fs-16 fw-500 mb-2">
                            <span className="svg-icon svg-icon-4 me-2">
                              {vendorDetails?.email && (
                                <img src={Email} alt="Email" />
                              )}
                            </span>
                            {vendorDetails?.email}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Col lg={12}>
                    <div className="d-flex flex-wrap flex-stack">
                      <div className="d-flex flex-column flex-grow-1 pe-8">
                        <div className="d-flex flex-wrap">
                          <div className="bg-light border rounded min-w-175px py-3 px-4 me-6 mb-3">
                            <div className="d-flex align-items-center">
                              <div className="fs-22 fw-bolder">
                                {vendorDetails?.leads
                                  ? vendorDetails?.leads + " " + "leads"
                                  : 0}
                              </div>
                            </div>
                            <div className="fw-500 fs-16">
                              {vendorString.leads}
                            </div>
                          </div>
                          <div className="bg-light border rounded min-w-175px py-3 px-4 me-6 mb-3">
                            <div className="d-flex align-items-center">
                              <div className="fs-22 fw-bolder">
                                {vendorDetails?.views
                                  ? vendorDetails?.views + " " + "Views"
                                  : 0}
                              </div>
                            </div>
                            <div className="fw-500 fs-16">
                              {vendorString.views}
                            </div>
                          </div>
                          <div className="bg-light border rounded min-w-175px py-3 px-4 me-6 mb-3">
                            <div className="d-flex align-items-center">
                              <div className="fs-22 fw-bolder">
                                {vendorDetails?.totalServices
                                  ? vendorDetails?.totalServices +
                                    " " +
                                    "Services"
                                  : 0}
                              </div>
                            </div>
                            <div className="fw-500 fs-16">
                              {vendorString.totalServices}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </div>
            </Card.Body>
            <Row className="align-items-center px-lg-9 px-6">
              <Col sm>
                <div className="d-flex h-70px">
                  <ul className="nav nav-stretch nav-line-tabs nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-18 fw-600">
                    {createTabs()}
                  </ul>
                </div>
              </Col>
            </Row>
          </Card>
          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active">
              <>{currentTab.content}</>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default VendorProfile;
